import _regenerator from "/root/workspace/__flow_work/__flow_builds/50aad046-ad0a-440d-80a1-803b30af1c95/workspace/wellcee-admin_pro/node_modules/.pnpm/@babel/runtime@7.28.6/node_modules/@babel/runtime/helpers/esm/regenerator.js";
import _objectSpread from "/root/workspace/__flow_work/__flow_builds/50aad046-ad0a-440d-80a1-803b30af1c95/workspace/wellcee-admin_pro/node_modules/.pnpm/@babel/runtime@7.28.6/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import _asyncToGenerator from "/root/workspace/__flow_work/__flow_builds/50aad046-ad0a-440d-80a1-803b30af1c95/workspace/wellcee-admin_pro/node_modules/.pnpm/@babel/runtime@7.28.6/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import "core-js/modules/es.array.flat.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.array.unscopables.flat.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.map.js";
import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
import { DualAxes } from "@antv/g2plot";
import chartMixin from "@/views/system/index/mixin/chartMixin";
export default {
  name: "FraudResolutionChart",
  mixins: [chartMixin],
  data: function data() {
    return {
      communityGrain: "day",
      loading: false,
      chart: null
    };
  },
  mounted: function mounted() {
    this.init();
  },
  methods: {
    getData: function getData() {
      var _arguments = arguments,
        _this = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee() {
        var other, type, param;
        return _regenerator().w(function (_context) {
          while (1) switch (_context.n) {
            case 0:
              other = _arguments.length > 0 && _arguments[0] !== undefined ? _arguments[0] : {};
              type = _arguments.length > 1 ? _arguments[1] : undefined;
              param = {
                grain: _this.communityGrain,
                start: _this.dateTime[0],
                end: _this.dateTime[1],
                groupBy: '',
                created: 'event_date'
              };
              return _context.a(2, new Promise(function (resolve, reject) {
                _this.$api.getPostChartData(_objectSpread(_objectSpread({}, param), other)).then(function (res) {
                  var data = res.data.map(function (i) {
                    return _objectSpread(_objectSpread({}, i), {}, {
                      category: type,
                      value: type === '手动处理率' ? Math.floor((Number(i.rate) || 0) * 10000) / 100 : i.automatic || i.manual || 0
                    });
                  });
                  resolve(data);
                }).catch(function (err) {
                  reject([]);
                });
              }));
          }
        }, _callee);
      }))();
    },
    getPostChartData: function getPostChartData() {
      var _this2 = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2() {
        return _regenerator().w(function (_context2) {
          while (1) switch (_context2.n) {
            case 0:
              return _context2.a(2, Promise.all([_this2.getData({
                chartName: "ads_fraud_daily_user_actions_stats_chart",
                valueName: "automatic"
              }, "自动处理数"), _this2.getData({
                chartName: "ads_fraud_daily_user_actions_stats_chart",
                valueName: "manual"
              }, "手动处理数")]).then(function (res) {
                if (res.length) {
                  return res.flat(2);
                }
                return [];
              }));
          }
        }, _callee2);
      }))();
    },
    init: function init() {
      var _this3 = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee3() {
        var barData, lineData;
        return _regenerator().w(function (_context3) {
          while (1) switch (_context3.n) {
            case 0:
              _this3.loading = true;
              _context3.n = 1;
              return _this3.getPostChartData();
            case 1:
              barData = _context3.v;
              _context3.n = 2;
              return _this3.getData({
                chartName: "ads_fraud_daily_user_actions_stats_chart",
                valueName: "rate",
                expression: "sum%28manual%29%20%2F%20%28sum%28manual%29%20%2B%20sum%28automatic%29%29"
              }, "手动处理率");
            case 2:
              lineData = _context3.v;
              _this3.loading = false;
              if (_this3.chart) {
                _this3.chart.changeData([barData, lineData]);
                _this3.restoreLegendSelection();
              } else {
                //自动处理数 柱状图 #598af9
                //手动处理数 柱状图 #f5b516
                //手动处理率 折线 #50d39c
                _this3.chart = new DualAxes("fraud-resolution", {
                  data: [barData, lineData],
                  xField: 'time',
                  yField: ['value', 'value'],
                  geometryOptions: [{
                    geometry: 'column',
                    isStack: true,
                    seriesField: 'category',
                    color: function color(_ref) {
                      var category = _ref.category;
                      var map = {
                        '自动处理数': '#598af9',
                        '手动处理数': '#f5b516'
                      };
                      return map[category] || '#f5b516';
                    }
                  }, {
                    geometry: 'line',
                    smooth: true,
                    seriesField: 'category',
                    color: '#50d39c'
                  }],
                  legend: {
                    position: "top",
                    offsetY: 70
                  },
                  tooltip: {
                    shared: true,
                    formatter: function formatter(datum) {
                      return {
                        name: datum.category,
                        value: datum.category === '手动处理率' ? "".concat(datum.value, "%") : datum.value
                      };
                    }
                  },
                  appendPadding: [70, 0, 0, 0]
                });
                _this3.chart.render();
                _this3.bindLegendSync();
              }
            case 3:
              return _context3.a(2);
          }
        }, _callee3);
      }))();
    },
    command: function command(type) {
      this.communityGrain = type;
      this.init();
    }
  }
};